module.exports = __webpack_public_path__ + "img/bleu4_noir.8ca2df0a.webp";